import {useRef} from 'react';
import MapLibreMap, {MapLayerMouseEvent, MapRef} from 'react-map-gl/maplibre';

import 'maplibre-gl/dist/maplibre-gl.css';

const RTL_TEXT_PLUGIN = {
  pluginUrl: 'https://unpkg.com/@mapbox/mapbox-gl-rtl-text@0.3.0/dist/mapbox-gl-rtl-text.js',
  lazy: false
};

type MapProps = {
  centerLat: number;
  centerLong: number;
  zoom: number;
  reuseMaps?: boolean;
  onMapLoad?: (map: MapRef | null) => void;
  interactiveLayerIds?: string[];
  onClick?: (event: MapLayerMouseEvent) => void;
  onMouseEnter?: (event: MapLayerMouseEvent) => void;
  onMouseLeave?: (event: MapLayerMouseEvent) => void;
  children?: React.ReactNode;
};

const Map = ({
  centerLat,
  centerLong,
  zoom,
  reuseMaps = true,
  onMapLoad,
  interactiveLayerIds,
  onClick,
  onMouseEnter,
  onMouseLeave,
  children
}: MapProps) => {
  const mapRef = useRef<MapRef>(null);

  return (
    <div className="relative h-full w-full min-h-0 min-w-0">
      <MapLibreMap
        attributionControl={false}
        ref={mapRef}
        reuseMaps={reuseMaps}
        mapStyle="https://tile.snappmaps.ir/styles/snapp-style/style.json"
        canvasContextAttributes={{antialias: true}}
        RTLTextPlugin={RTL_TEXT_PLUGIN}
        interactiveLayerIds={interactiveLayerIds}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        initialViewState={{
          latitude: centerLat ? centerLat : 35.715298,
          longitude: centerLong ? centerLong : 51.404343,
          zoom: zoom ? zoom : 13
        }}
        style={{width: '100%', height: '100%'}}
        onLoad={() => {
          onMapLoad?.(mapRef.current);
          requestAnimationFrame(() => {
            mapRef.current?.resize();
          });
        }}
      >
        {children}
      </MapLibreMap>
    </div>
  );
};

export default Map;
